export class QuotationEntityIdDto {
    portfolioId: number;
    quotationId: string="";
}
